import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7e666da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["element-loading-text"]

import { useRoute } from 'vue-router'
import { LoginService, LoginType } from '@/services/login.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'cascade-login',
  setup(__props) {

const { t } = useI18n()
const injector = useReflectiveInjector([LoginService])
const loginService = injector.get(LoginService)
const route = useRoute()

loginService.doLogin({
  token: route.query.parent_token,
  parent_team_id: route.query.parent_team_id,
  child_team_id: route.query.child_team_id,
  access_code: route.query.access_code,
  login_type: LoginType.cascade,
} as any).then(() => {
  ElMessage.success(t('login.enteredSubConsole'))
})


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "login-transit-wrap",
    "element-loading-text": _unref(t)('login.loggingIn')
  }, null, 8, _hoisted_1)), [
    [_directive_loading, true]
  ])
}
}

})